import { connect } from 'react-redux'
import { actions } from '../../store/dashboard'
import { actions as globalSettingsActions } from '../../store/globalSettings'

function mapStateToProps(state) {
  return {
    statistics: state.dashboard.statistics,
    pending: state.dashboard.pending,
    recentlyClients: state.dashboard.recentlyClients,
    optionsChart: state.dashboard.optionsChart,
    numberAccounts: state.dashboard.numberAccounts,
    mapChart: state.dashboard.mapChart,
    authUser: state.auth,
    announcementBanner: state.globalSettings.announcementBanner,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetch: () => dispatch(actions.getInformation({})),
    getGlobalSettings: params =>
      dispatch(globalSettingsActions.getGlobalSettings(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)